<template>
  <div :class="{'logo': true, 'playModeScale': scaleMode == 'playMode'}">
    <router-link to="/">
      <img src="@/assets/logo.png">
      <span>Frogero</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    scaleMode: String
  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 10rem;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1.8rem;
  @media (max-width: 600px) {
    width: 3rem;
  }

  img {
    width: 2.2rem;
    margin-top: 0.1rem;
  }

  span {
    margin-left: 0.8rem;
    font-family: 'Oswald';
    @media (max-width: 600px) {
      display: none;
    }
  }

  a {
    text-decoration: none;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.playModeScale {
  @media (max-width: 1000px) {
    width: 3rem;
  }
  span {
    @media (max-width: 1000px) {
      display: none;
    }
  }
}
</style>